import create from './create';
import get from './get';
import update from './update';
export default [create, get, update];
